// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3425) return "static/chunks/3425-8dace7084d5bbfb7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3225 ? "e78b34b7" : chunkId) + "." + {"50":"68d2f1473d36db02","213":"9b2ff62a83f5dbbc","347":"f83775d821b9e9b2","3225":"65d4ef3e3e64a97b","4972":"4257cb84b971ac4c","5238":"24ab7ac96ce8698f","7457":"cfb4ddc3043dc4ee","9038":"11550f759834a1c4","9258":"b56a42ca49433676","9579":"c84de418c3f27fd2"}[chunkId] + ".js";
};